import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

export default function (duration: duration.Duration): string {
    if (!duration || duration.asMinutes() < 0) {
        return null;
    }

    const elements: string[] = [];

    if (duration.asDays() >= 1) {
        elements.push(Math.floor(duration.asDays()) + 'j');
    }
    if (duration.hours() > 0 || elements.length > 0) {
        elements.push(duration.hours() + 'h');
    }
    elements.push(duration.minutes() + 'min');

    if (elements.length > 2) {
        return [elements[0], elements[1]].join(' ');
    }

    return elements.join(' ');
}
